import { __assign } from "tslib";
import { createFakeGetResponder, createFakePostResponder, createFakePutResponder, createFakeDeleteResponder } from '../test-utils';
import { createHttpTestKit } from '../http/test-kit';
import { createSlaApi, } from '.';
import { createTicketsSlaInsightsApiTestkit } from './insights/testkit';
export var createSlaApiTestkit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createSlaApi('', fakeHttp);
    var testKit = {
        whenGetAll: function () {
            return createFakeGetResponder(fakeHttp, '/sla');
        },
        whenGet: function (dto) {
            return createFakeGetResponder(fakeHttp, "/sla/".concat(dto.id));
        },
        whenAdd: function (dto) {
            return createFakePostResponder(fakeHttp, "/sla")(dto);
        },
        whenEnable: function (dto) {
            return createFakePutResponder(fakeHttp, "/sla/".concat(dto.id, "/enable"))(dto);
        },
        whenUpdate: function (dto) {
            return createFakePutResponder(fakeHttp, "/sla/".concat(dto.id))(dto);
        },
        whenDelete: function (dto) {
            return createFakeDeleteResponder(fakeHttp, "/sla/".concat(dto.id));
        },
        whenReorder: function (dto) {
            return createFakePostResponder(fakeHttp, "/sla/reorder")(dto);
        },
        onInsights: createTicketsSlaInsightsApiTestkit('')
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map